import styled from 'styled-components'
import { font } from 'lib/core/resources/helpers/styled'
import caretDownSvg from 'resources/svg/icons/caret-down.svg'

export const Wrapper = styled.div`
  > div {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;

    label {
      font: ${font('default', 'medium', '14px/1.5')};
    }

    select {
      appearance: none;
      background: transparent url(${caretDownSvg}) no-repeat;
      background-size: 13px;
      background-position-x: 98%;
      background-position-y: 8px;
      border: 1px solid ${props => props.theme.palette.general.greyDark};
      border-radius: 6px;
      padding: 10px 30px 10px 10px;
    }

    select,
    input {
      height: 44px;
    }
  }

  .search {
    .field {
      position: relative;

      > div {
        padding-bottom: 0;
      }

      input {
        padding: 10px;
        padding-right: 40px;
        box-sizing: border-box;
        width: 100%;
      }

      button {
        position: absolute;
        top: 0;
        right: 0;
        height: 100%;
        background: transparent;
        border: none;
        display: flex;
        align-items: center;

        &:active {
          outline: none;
        }

        svg {
          width: 24px;
          height: 24px;
        }
      }
    }
  }
`
